import '../assets/css/ProjectSection.css'
import 'bootstrap/dist/css/bootstrap.min.css'; 
// import Roll from 'react-reveal/Roll';
// import Slide from 'react-reveal/Slide';
import Rotate from 'react-reveal/Rotate';
import Flip from 'react-reveal/Flip';

function ProjectSection() {
    return (
            <div class="ProejectSec container">
                     <div>
                <h2>Projects</h2>
               
                {/* <Slide left> */}
                <Rotate top left>
                <div>
                <div class="row">
                   
                    <div class="ProjectDiv div1 col border p-0 m-2" style={{height:300}}>
                        <div class="ProjectDivIn">
                            <div>
                        <h1>Chitchat</h1>
                        <p>Django | Tailwind CSS | CSS | HTML</p>
                        </div>
                        </div>
                    </div>
                    <div class="ProjectDiv div2 col border p-0 m-2" style={{height:300}}>
                        <div class="ProjectDivIn">
                            <div>
                        <h1>OGDS</h1>
                        <p>Flask | Bootstrap | CSS | HTML</p>
                        </div>
                        </div>
                    </div>
                    <div class="ProjectDiv div3 col border p-0 m-2" style={{height:300}}>
                        <div class="ProjectDivIn">
                            <div>
                        <h1>Mini Paint</h1>
                        <p>Python | Tkinter</p>
                        </div>
                        </div>
                    </div>
                    
                </div>
                </div>
                </Rotate>
                {/* </Slide> */}
                <Flip left>
                <div className="button">
                    <a href="/projects"><button>Show me more</button></a>
                </div>
                </Flip>
                </div>
            </div>
        );
    }
    
export default ProjectSection;